import globalLinkTaggingParams from "./globalTagging/globalLinkTaggingParams";
import { loadTagging } from "./loadTagging";


 const linkTagging = (params) => {
    loadTagging({ ...globalLinkTaggingParams, ...params }, true);
}

export default linkTagging;
